import { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { HeaderActionArea } from "@deere/fuel-react/HeaderActionArea";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DigitalAssistant from "../chat-bot/DigitalAssistant";
import {useFeatureToggles, useUserDetails} from "../../hooks";

export const CustomHeaderAction = () => {
  const { oktaAuth } = useOktaAuth();
  const { oktaDetails, loading } = useUserDetails();

  const logout = () => {
    oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin });
  };

  const username = oktaDetails.username || "User";
  const userType = oktaDetails.usertype || "User Type";

  const [accountAnchorEl, setAccountAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAccountAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAccountAnchorEl(null);
  };
  const DigitalAssitantShow = () => {
    const {isEDIAgentEnabled} = useFeatureToggles();
    if (isEDIAgentEnabled) return <DigitalAssistant/>
  }

  return (
    <HeaderActionArea>
      <>
          {<DigitalAssitantShow/>}
        <Button
          endIcon={<fuel-icon name={"keyboard_arrow_down"} />}
          onClick={handleClick}
          startIcon={<Avatar size={"small"} src={"./ProfilePic1.jpeg"} />}
          variant={"headerAction"}
        >
          {username}
        </Button>
        <Menu
          anchorEl={accountAnchorEl}
          onClose={handleClose}
          open={Boolean(accountAnchorEl)}
        >
          {/* <MenuItem>{userType}</MenuItem> */}
          <MenuItem onClick={logout}>{"Sign Out"}</MenuItem>
        </Menu>
      </>
    </HeaderActionArea>
  );
};
